import { defaultBobaProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/boba/default-constants';

export const OOLONG_SWAP_CONTRACT_ADDRESS = '0x17C83E2B96ACfb5190d63F5E46d93c107eC0b514';

export const OOLONG_SWAP_PROVIDER_CONFIGURATION = defaultBobaProviderConfiguration;
